export const RECLAIM_SHOPIFY_APP_LISTING_URL =
  "https://apps.shopify.com/reclaim-app";

export const RECLAIM_INSTALL_APP_PROMPT_DEFER_HOURS = 24;

export const RECLAIM_INSTALL_APP_PROMPT_DEFER_SETTING_KEY =
  "disputes/reclaimShopifyAppInstallPromptDeferredUntil";

export const RECLAIM_INSTALL_APP_MODAL_UI_SELECTOR =
  "reclaim-install-app-modal";

export const RECLAIM_INSTALL_APP_MODAL_ACTIVE_BODY_ATTRIBUTE =
  "data-reclaim-install-app-modal-active";

export const RECLAIM_INSTALL_APP_MODAL_EVENTS = {
  shown: "reclaim-install-app-modal-shown",
  openListingClicked: "reclaim-install-app-modal-open-listing-clicked",
  deferred: "reclaim-install-app-modal-deferred",
} as const;
